import { useEffect, useRef, useState } from "@wordpress/element";
// import BPlayer from "../../BPlayer";
import { useStyleRenderer } from "../../../../wp-utils/v1/hooks";
// import { htmlToElement } from "./../../../wp-utils/v1";
// import Watermark from "../../Components/Watermark";
let i = 1;
const Preview = ({ uniqueId, preset }) => {
  const [player, setPlayer] = useState(null);
  const { CSS } = useStyleRenderer({ ...preset.preset }, `#${uniqueId}`);

  const domRef = useRef(null);

  useEffect(() => {
    if (player) {
      player.destroy();
    }
    const newPlayer = new Plyr(domRef.current?.querySelector("#player"), preset?.preset?.options);
    newPlayer.volume = 0.5;
    setPlayer(newPlayer);
  }, [preset?.preset?.options?.controls]);

  return (
    <>
      {/* <Watermark player={player} domRef={domRef} watermark={preset?.preset.watermark} uniqueId={uniqueId} /> */}
      <style dangerouslySetInnerHTML={{ __html: CSS }}></style>
      <div id={uniqueId} ref={domRef} className={`ytPreview ytWrapper ytPlayer ${preset?.preset?.hideControlsWhenPause ? "hideControlsWhenPause" : ""}`}>
        <video id="player" data-poster="https://picsum.photos/536/354"></video>
      </div>
    </>
  );
};

export default Preview;
